import React from 'react';
import { Alert, PageHeader } from 'udesk-ui';
import SdkLoader from 'udesk-react/src/components/sdk-loader';
import FinanceCenterComponent from './component';
import './style.scss';

export default class FinanceCenterTemplate extends FinanceCenterComponent {
    render() {
        const { state, privates, actions, locales } = this;
        const { releaseVersionUrl, billingSdkJsUrl, billingSdkCssUrl, unavailable } = state;
        return (
            <div className="udesk-qa-web-page">
                <PageHeader
                    className="udesk-qa-web-page-header"
                    title={/* 财务管理 */ locales.components.pages.financeCenter.title}
                />
                <div className="udesk-qa-web-page-body">
                    <div className="udesk-qa-web-page-body-root finance-center-page">
                        <If condition={unavailable}>
                            <Alert
                                type="warning"
                                showIcon={true}
                                message={/* 当前环境未配置计费系统 */ locales.components.pages.financeCenter.unavailable}
                            />
                        </If>
                        <If condition={billingSdkJsUrl}>
                            <div
                                id={privates.renderContainerId}
                                className="finance-center-page-sdk"
                            >
                                <SdkLoader
                                    releaseVersionUrl={releaseVersionUrl}
                                    jsUrl={billingSdkJsUrl}
                                    cssUrl={billingSdkCssUrl}
                                    loadErrorMessage={
                                        /* 计费系统加载失败，请稍后重试 */
                                        locales.components.pages.financeCenter.loadError
                                    }
                                    onLoaded={actions.onLoaded}
                                    onDestroying={actions.destroyBillingSdk}
                                />
                            </div>
                        </If>
                    </div>
                </div>
            </div>
        );
    }
}
